import { SidebarLayout } from '@/layouts/sidebar/SidebarLayout';
import { Helmet } from 'react-helmet-async';
import { Permission } from '@/models/user';
import { PageWithLayout } from '@/models/page';
import { VoucherTemplateListContent } from '@starjack/widgets/voucherTemplates';
import { useAuthentication } from '@starjack/features/authentication';
import { VoucherToolGuard } from '@/guards/VoucherToolGuard';

const VoucherTemplates: PageWithLayout = () => {
    const { liftOperatorData } = useAuthentication();

    return (
        <VoucherToolGuard>
            <Helmet>
                <title>Gutscheinvorlagen | Starjack Admin</title>
            </Helmet>

            <VoucherTemplateListContent
                liftOperatorId={liftOperatorData?.liftOperatorId}
            />
        </VoucherToolGuard>
    );
};

VoucherTemplates.getLayout = (page) => <SidebarLayout>{page}</SidebarLayout>;

VoucherTemplates.isProtected = true;

VoucherTemplates.permissions = [Permission.VOUCHER_TEMPLATE_NAV];

export default VoucherTemplates;
